<section>
  <p-card>
    <h2 *ngIf="title" class="card-title" data-autoid="cinch-card-title">{{ title }}</h2>
    <h3 *ngIf="subtitle" class="card-subtitle" data-autoid="cinch-card-subtitle">{{ subtitle }}</h3>
    <ng-content></ng-content>
  </p-card>
</section>
